export const filterObjectsWithPriceKey = (dataArray) => {
  if (!dataArray) return false;
  const hasNullOrZeroPrice = dataArray.some((obj) => {
    if (obj.hasOwnProperty("price")) {
      return obj.price === 0 || obj.price === null || obj.price === undefined;
    }
    return false;
  });

  return hasNullOrZeroPrice;
};
